import { render, staticRenderFns } from "./InstructionsLanguagePicker.vue?vue&type=template&id=89363c0e&scoped=true"
import script from "./InstructionsLanguagePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./InstructionsLanguagePicker.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InstructionsLanguagePicker.vue?vue&type=style&index=0&id=89363c0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89363c0e",
  null
  
)

export default component.exports